import React from 'react';
import { useCascadeDropdownContext } from '../useCascadeDropdownContext';
import Tag from '../../../tag';
import * as Tooltip from '../../../tooltip';
import { Outline } from '../../../icons';
export const Trigger = ({ language = 'en', labelText = 'Please select', tooltipText = labelText, }) => {
    const { selectedType } = useCascadeDropdownContext();
    return !selectedType ? (React.createElement(Tag, { Icon: Outline.Edit, lang: language, size: "MEDIUM", label: labelText, bgColor: "SNOW_100", borderColor: "INK_200", hoverColor: "PRIMARY_100" })) : (React.createElement(Tooltip.Primary, { direction: "TOP_CENTER", text: tooltipText },
        React.createElement(Tag, { lang: language, size: "MEDIUM", label: labelText })));
};
export default Trigger;
//# sourceMappingURL=Trigger.js.map